export default __webpack_public_path__ + "static/media/search.b8b2c9dd.webp";